/* eslint-disable */
import React from 'react';
import { IExpansion, IParentExpansion, ExpansionProps } from './types';

const SLIDES_EXPANDED_PANELS_KEY = "slidesExpandedPanels";
export abstract class Expansion<T extends ExpansionProps> extends React.PureComponent<T> implements IExpansion {
  state = {
    expanded: this.initialExpansionState
  }

  get parent(): IParentExpansion {
    const props = this.props as any;
    return props.parent as IParentExpansion;
  }

  get expanded() {
    return this.state.expanded;
  }
  get initialExpansionState(): boolean {
    if (this.props.expanded === false) {
      return false;
    } else if (this.props.expanded || this.getStoredExpansionState(this.props.expansionKey)) {
      return true;
    }
    return false;
  }

  expand = () => {
    this.persistExpansionState(this.props.expansionKey, true);
    this.setState({ expanded: true });
  }

  collapse = () => {
    this.persistExpansionState(this.props.expansionKey, false);
    this.setState({ expanded: false });
  }

  toggleExpand = () => { 
    this.persistExpansionState(this.props.expansionKey, !this.state.expanded);
    this.setState({expanded: !this.state.expanded});
  }

  persistExpansionState = (panelKey: string | undefined, isExpanded: boolean) => {
    if (panelKey) {
      try {
        let expandedPanels = JSON.parse(sessionStorage.getItem(SLIDES_EXPANDED_PANELS_KEY) || "[]");
        if (isExpanded && expandedPanels.indexOf(panelKey) === -1) {
          expandedPanels.push(panelKey);
        } else if (!isExpanded) {
          expandedPanels = expandedPanels.filter(key => key !== panelKey); 
        }
        sessionStorage.setItem(SLIDES_EXPANDED_PANELS_KEY, JSON.stringify(expandedPanels)); 
      } catch (e) {
        console.error(e);
        sessionStorage.setItem(SLIDES_EXPANDED_PANELS_KEY, "[]");
      } 
    }
  }
  getStoredExpansionState(panelKey: string | undefined): boolean {
    if (panelKey) {
      try {
        let expandedPanels = JSON.parse(sessionStorage.getItem(SLIDES_EXPANDED_PANELS_KEY) || "[]");
        return expandedPanels.indexOf(panelKey) !== -1;
      } catch (e) {
        console.error(e);
        sessionStorage.setItem(SLIDES_EXPANDED_PANELS_KEY, "[]");
      } 
    }
    return false;
  }
}

export default Expansion;
